export default __webpack_public_path__ + "static/media/225-deg.fed75c7e.svg";